import {useQuery} from '@tanstack/react-query';
import crmOffPlatformCreatorsFetchers from '@/api/fetchers/crm/offPlatformCreators';

export const OFF_PLATFORM_CREATOR_QUERY_KEY = 'crmOffPlatformCreator';

export default function useOffPlatformCreatorQuery({
  id,
  brandId,
  enabled = true,
}: {
  id?: string;
  brandId?: string | null;
  enabled?: boolean;
}) {
  return useQuery({
    queryKey: [OFF_PLATFORM_CREATOR_QUERY_KEY, id, brandId],
    queryFn: () =>
      crmOffPlatformCreatorsFetchers.get({
        id: id as string,
        brandId: brandId as string,
      }),
    enabled: enabled && !!id && !!brandId,
    refetchOnWindowFocus: false,
  });
}
